<div [class]="wrapperClasses" [ngClass]="{'highlight-invalid': question.input.highlightOnInvalid && question.input.control.invalid}" #wrapperContainer>
    <div class="edit-prompt" #promptContainer>
        <ng-template #promptTemplate></ng-template>
    </div>
    <ng-template #questionTemplate></ng-template>
    <ng-content></ng-content>
</div>